<ion-header>
	<app-account-toolbar
		src="../../../assets/dean_and_david/burger-menu/login.svg"
		title="sign_in.title"
		(back)="goBack()"
	></app-account-toolbar>
</ion-header>
<ion-content>
	<ion-row *ngIf="!loading" class="ion-justify-content-center" role="region" aria-label="Content center row">
		<ion-col class="ion-padding ion-margin-top wrapper" size="12" size-lg="6" size-md="8" [formGroup]="signInForm">
			<ion-label class="stacked">{{'sign_in.email' | translate }}</ion-label>
			<ion-item class="input ion-invalid" lines="none" [class.ion-info]="!isValid('email') && isValidByPattern('email')">
				<ion-input formControlName="email" name="email" placeholder="{{'sign_in.email' | translate }}" type="email"></ion-input>
			</ion-item>
			<div class="error_container" role="region" aria-label="Error message container">
				<ion-note class="input-error" [class.visible]="isValid('email')" slot="error">{{'sign_in.required' | translate}}</ion-note>
			</div>

			<ion-label class="stacked">{{'sign_in.password' | translate }}</ion-label>
			<ion-item class="input ion-invalid" lines="none" [class.ion-info]="!isValid('password') && isValidByPattern('password')">
				<ion-input
					formControlName="password"
					[type]="showPassword ? 'text' : 'password'"
					name="password"
					placeholder="{{'sign_in.password' | translate }}"
				></ion-input>

				<ion-icon
					(click)="showPassword = !showPassword"
					[src]='showPassword ? "../../../assets/icon/eye.svg" : "../../../assets/icon/eye_dis.svg"'
					slot="end"
					src="/assets/icon/eye.svg"
					role="button"
					aria-label="Toggle password visibility"
				></ion-icon>
			</ion-item>
			<div class="error_container" role="region" aria-label="Error message container">
				<ion-note class="input-error" [class.visible]="isValid('password')" slot="error"
					>{{'sign_in.required' | translate}}</ion-note
				>
			</div>

			<div class="forgot-password" role="region" aria-label="Forgot password section">
				<h3 (click)="showResetPasswordDialog()">{{ 'sign_in.forgot_password' | translate }}</h3>
			</div>
			<ion-button (click)="signIn()" [disabled]="isValid()" class="ion-margin-bottom" expand="block"
				>{{ 'sign_in.login' | translate }}</ion-button
			>
			<ion-button (click)="signUp()" class="sign-up-button" expand="block">{{ 'sign_in.reg' | translate }}</ion-button>

			<div class="button-wrapper">
				<ion-button class="google" (click)="signInWithGoogle()" aria-label="Sign in with Google">
					<ion-icon src="../../../assets/dean_and_david/google.svg" role="img" aria-label="Google icon"></ion-icon>
					<p>Weiter mit Google</p>
				</ion-button>
				<ion-button class="facebook" (click)="signInWithFacebook()">
					<ion-icon src="../../../assets/dean_and_david/facebook.svg" role="img" aria-label="Facebook icon"></ion-icon>
					<p>Weiter mit Facebook</p>
				</ion-button>
				<ion-button class="apple" (click)="signInWithApple()" aria-label="Sign in with Apple">
					<ion-icon src="../../../assets/dean_and_david/apple.svg" role="img" aria-label="Apple icon"></ion-icon>
					<p>Mit Apple anmelden</p>
				</ion-button>
			</div>
		</ion-col>
	</ion-row>
	<ion-row *ngIf="loading" class="ion-justify-content-center" role="region" aria-label="Loading content">
		<ion-spinner class="main-color"></ion-spinner>
	</ion-row>
</ion-content>
